import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

// --- INTERCEPTEUR POUR LE TOKEN ---
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    // On ajoute le préfixe 'Bearer ' indispensable pour SimpleJWT
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export const productService = {
  // Gestion de la pagination (Django renvoie { count, next, previous, results })
  getAllProducts: async (params = {}) => {
    const response = await api.get('/lunettes/', { params });
    // Si la pagination est activée, tes produits sont dans response.data.results
    return response.data; 
  },
  
  getProductBySlug: async (slug) => {
    // Attention : si ton ViewSet utilise l'ID par défaut, utilise /lunettes/${id}/
    const response = await api.get(`/lunettes/${slug}/`);
    return response.data;
  },

  // Ajout du service d'authentification
  login: async (username, password) => {
    const response = await api.post('/auth/token/', { username, password });
    if (response.data.access) {
      localStorage.setItem('access_token', response.data.access);
      localStorage.setItem('refresh_token', response.data.refresh);
    }
    return response.data;
  }
};

export default api;